import {
    type FieldPath,
    type FieldValues,
    type UseFormReturn,
    useController,
} from 'react-hook-form';

import { Icon } from '@gitbook/spine-icons';
import { IconPickerButton } from '@gitbook/spine-react';

import { ContentIcon } from '../../Icons';

/**
 * Icon picker field for selecting icon.
 */
export function IconPickerField<TFieldValues extends FieldValues>(props: {
    form: UseFormReturn<TFieldValues>;
    name: FieldPath<TFieldValues>;
    disabled?: boolean;
}) {
    const { form, name, disabled } = props;
    const { field } = useController({
        name,
        control: form.control,
        rules: {
            required: false,
            maxLength: 50,
            minLength: 1,
        },
        disabled,
    });
    const { value: icon, onChange } = field;

    return (
        <IconPickerButton
            accept={['icon']}
            label={icon ? 'Change icon' : 'Add icon'}
            aria-description={icon ? `Selected icon: ${icon}` : undefined}
            value={icon}
            placeholder={Icon.AddNew}
            renderIcon={(iconProps) => <ContentIcon {...iconProps} />}
            onPick={onChange}
            onRemove={() => onChange(null)}
            disabled={disabled}
        />
    );
}
